import { helper } from '@ember/component/helper';

import { importSync } from '@embroider/macros';

export function importAsset([assetPath]: [string]) {
  if (!assetPath.startsWith('/illustrations/')) {
    throw new Error(`Asset not found: ${assetPath}`);
  }
  const fileName = assetPath.replace(/^\/illustrations\//, '');
  const module = importSync(`@repo/visual-assets/illustrations/${fileName}`) as {
    default: string;
  };
  return module.default;
}

export default helper(importAsset);
